import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/containers/dynamic-form/dynamic-form.component';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { ISystemsExternal } from 'src/app/domain/registration/models/ISystemExternal';
import { SystemsExternalTypeIdEnum } from 'src/app/domain/registration/enums/system-external-type.enum';
import { PermissionService } from 'src/app/shared/permission.service';

@Component({
  selector: 'app-systemsExternal-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
})
export class SystemsExternalCESComponent implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;
  config: IFieldConfig[] = CES_CONFIG_FIELDS;
  data: ISystemsExternal;
  type: TypeCesEnum;
  title = '--';

  get typeCesEnum() {
    return TypeCesEnum;
  }

  setFields() {
    // PADRÃO
    this.form.setDisabled('submit', true);
    this.form.setValue('id', this.data?.id);
    // NA CÓPIA ALTERA APENAS ESSES
    this.form.setValue('type', this.data?.type);
    this.form.setValue('name', this.data?.name);
    this.form.setValue('dueDate', this.data?.dueDate);
    this.form.setValue('image', this.data?.image);  
  }

  constructor(
    public dialogRef: MatDialogRef<SystemsExternalCESComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { type: TypeCesEnum; element: ISystemsExternal },
    private cdr: ChangeDetectorRef,
    public permissionService: PermissionService,
  ) {
    this.type = data.type;
    this.data = data.element;
    this.title = this.type;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    let previousValid = this.form.valid;

    this.form.changes.subscribe(() => {
      if (this.form.valid !== previousValid) {
        previousValid = this.form.valid;
        this.form.setDisabled('submit', !previousValid);
      }
    });

    this.setFields();
    this.cdr.detectChanges();
  }

  onSubmit(value: { [name: string]: any }) {
    value['type'] = SystemsExternalTypeIdEnum[value['type']];
    this.dialogRef.close({ element: value });
  }

  onCancel() {
    this.dialogRef.close();
  }

  changeType(type: TypeCesEnum) {
    this.type = type;
    this.dialogRef.close({ changeType: type });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }
}
